/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import BaseModal from 'src/common/components/Modal';
import UtilInputs from 'src/common/components/UtilInputs';
import { Grid, makeStyles } from '@material-ui/core';
import { filesAPI } from 'src/api/modules/files';
import { useParams, useHistory } from 'react-router-dom';
import { institutionsAPI } from 'src/api/modules/institutions';
import { fundamentalsAPI } from 'src/api/modules/fundamentals';
import notice from 'src/common/components/Notice';
import PageLayout from 'src/common/components/PageLayout';
import CustomButton from 'src/common/components/CustomButton';
import DeleteConsultModal from './DeleteConsultModal';
import TablaDocumentos from '../HightResolution.js/TablaDocumentos';
import { inclusionThemesAPI } from 'src/api/modules/inclusionThemes';
import {
	addTopicsInputs,
	editTopicsInputs,
	defaultAddTopics,
	update_button,
} from './utils/list_data';

const useStyles = makeStyles({
	containerButtons: {
		marginTop: 20,
		width: '100%',
		margin: 0,
	},
	subContainerButtons: {
		flexDirection: 'row',
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'flex-end',
	},
	root: {
		marginTop: 20,
		width: '100%',
		margin: 0,
	},
});

const AddTopicModal = ({ open, setOpen, add, session, onSuccess }) => {
	const { id } = useParams();
	const classes = useStyles();
	const [institutions, setInstitutions] = useState([]);
	const [fundamentals, setFundamentals] = useState([]);
	const [items, setItems] = useState([]);
	const { user } = useSelector((state) => state.auth);
	const systemLevelRole = user?.organos[0].nombrePerfil.toUpperCase();
	const inpustfile = [1, 2, 3, 4];
	const [topic, setTopic] = useState(defaultAddTopics);
	const [sendDisabled, setsendDisabled] = useState(true);
	const [disableForm, setDisableForm] = useState(false);
	const [flagRender, setFlagRender] = useState(false);
	const [modalDelete, setModalDelate] = useState(false);
	const [idSession, setIdSession] = useState();
	const history = useHistory();

	useEffect(() => {
		getInstitutions();
		getFundamentals();

		if (id) {
			inclusionThemesAPI
				.getTopic(id)
				.then((response) => {
					let data = { ...response };
					let institutionsItems = [];
					if (response.instituciones.length > 0) {
						response.instituciones.forEach((item) => {
							institutionsItems.push({
								value: item.institucion.id,
								text: item.institucion.nombre,
							});
						});
					}

					data = {
						...data,
						instituciones: institutionsItems,
					};
					setTopic(data);
					setIdSession(data.idSesion);
					getArchivos(
						response.sesion.organoId,
						response.sesion.numero_sesion,
						response.nombreTema,
						data
					);
				})
				.catch(() => notice('Ocurrio un error', 'error'));

			if (
				systemLevelRole !== 'ADMINISTRADOR GENERAL' &&
				systemLevelRole !== 'ENLACE'
			) {
				setDisableForm(true);
			}
			setFlagRender(false);
		}
	}, [id]);

	const handleChange = ({ target }) => {
		const { name, value } = target;
		setTopic({ ...topic, [name]: value });
	};

	const getInstitutions = () => {
		institutionsAPI
			.get('unidadAdministrativa')
			.then((response) => {
				if (response && response.length > 0) {
					let institutionsFlag = [];
					response.forEach((ele) => {
						institutionsFlag.push({
							value: ele.id,
							text: ele.nombre,
						});
					});
					setInstitutions([...(institutionsFlag || [])]);
				}
			})
			.catch(() => notice('Ocurrio un error', 'error'));
	};

	const getFundamentals = () => {
		fundamentalsAPI
			.get('get')
			.then((response) => {
				if (response && response.length > 0) {
					let fundamentalsFlag = [];
					response.forEach((item) => {
						fundamentalsFlag.push({
							value: item.normativa,
							text: item.normativa,
						});
					});
					setFundamentals([...(fundamentalsFlag || [])]);
				}
			})
			.catch((e) => notice('Ocurrio un error', 'error'));
	};

	const createTopic = () => {
		if (
			topic.nombreTema === (null || '') ||
			topic.ResponsibleArea === (null || '') ||
			topic.fundamentoLegal === (null || '') ||
			topic.detalleFundamento === (null || '') ||
			topic.tipo === (null || '')
		) {
			notice('Debe llenar todos los campos', 'info');
		} else {
			const ResponsibleArea = [];
			if (topic.instituciones) {
				topic.instituciones.forEach((item) => {
					ResponsibleArea.push({
						idInstitucion: item.value,
					});
				});
			}

			let addTopic = {
				...topic,
				instituciones: [...ResponsibleArea],
				idSesion: session,
			};
			let aditTopic = {
				...topic,
				instituciones: [...ResponsibleArea],
				estatus: 'EP',
			};
			if (add === true) {
				delete addTopic.id;
				inclusionThemesAPI
					.post({ ...addTopic })
					.then((response) => {
						onSuccess('Tema creado con éxito', 'success', response);
						clearForm();
					})
					.catch(() => notice('Ocurrio un error', 'error'));
			} else {
				delete aditTopic.archivos;
				inclusionThemesAPI
					.put(id, { ...aditTopic })
					.then((response) => {
						notice('Tema actualizado con exito', 'success');
					})
					.catch(() => notice('Ocurrio un error', 'error'));
			}
		}
	};

	const getArchivos = (organID, nameSession, nombreTema, data) => {
		filesAPI
			.get('TEMAINCLUIDO', id)
			.then((x) => {
				x = x.slice().reverse();
				let element = [];
				element.push({
					tema: nombreTema,
					organo: organID,
					totalIcons: 4,
					perfil: systemLevelRole,
					userName:
						user.nombre +
						' ' +
						user.apellidoPaterno +
						' ' +
						user.apellidoMaterno,
					dataMinos: builddatosinos(x, id),
					nameSesion: nameSession,
					enviadoEnlace: data.enviadoEnlace,
					enviadoRO: data.enviadoRO,
					enviadoRS: data.enviadoRS,
				});
				setItems(element);
			})
			.catch(() => notice('Ha ocurrido un error', 'error'));
	};
	const getIsDisabledResponsable = (oficio, tarjeta, presentacion) => {
		let isdabled = true;

		if (
			typeof oficio != 'undefined' &&
			typeof tarjeta == 'undefined' &&
			typeof presentacion == 'undefined' &&
			(oficio?.validaSeguimiento == 'APO' || oficio?.validaSeguimiento == 'A')
		)
			isdabled = false;

		if (
			typeof oficio != 'undefined' &&
			typeof tarjeta != 'undefined' &&
			typeof presentacion != 'undefined'
		) {
			if (
				(oficio.validaSeguimiento == 'APO' &&
					tarjeta.validaSeguimiento == 'APO' &&
					presentacion.validaSeguimiento == 'APO') ||
				(oficio.validaSeguimiento == 'A' &&
					tarjeta.validaSeguimiento == 'A' &&
					presentacion.validaSeguimiento == 'A')
			)
				return false;
		}
		return isdabled;
	};
	const builddatosinos = (archivos, idEntidad) => {
		const oficio = archivos.find((x) => x.tipo === 'O');
		const tarjeta = archivos.find((x) => x.tipo === 'T');
		const presentacion = archivos.find((x) => x.tipo === 'P');
		const adicional = archivos.find((x) => x.tipo === 'A');
		let isSendDisabled = oficio == undefined;

		if (!isSendDisabled) {
			isSendDisabled =
				typeof tarjeta != 'undefined' || typeof presentacion != 'undefined'
					? true
					: false;
			if (isSendDisabled)
				isSendDisabled =
					typeof tarjeta != 'undefined' && typeof presentacion != 'undefined'
						? false
						: true;
		}

		if (systemLevelRole != 'ENLACE') {
			isSendDisabled = getIsDisabledResponsable(oficio, tarjeta, presentacion);
		}
		const datosMinos = [
			{
				id: oficio ? oficio.id : '',
				idEntidad: idEntidad,
				tipo: 'O',
				entidad: 'TEMAINCLUIDO',
				estatus: oficio ? oficio.validaSeguimiento : '',
				isSendDisabled: isSendDisabled,
				ruta: 'temas/' + idEntidad + '/',
				title: 'Oficio',
				nombre: oficio ? oficio.nombre : '',
				message: oficio
					? oficio.rechazos.length > 0
						? 'Motivo de Rechazo: ' + oficio.rechazos[0].mensaje
						: ''
					: '',
			},
			{
				id: tarjeta ? tarjeta.id : '',
				estatus: tarjeta ? tarjeta.validaSeguimiento : '',
				idEntidad: idEntidad,
				isSendDisabled: isSendDisabled,
				tipo: 'T',
				entidad: 'TEMAINCLUIDO',
				ruta: 'temas/' + idEntidad + '/',
				title: 'Tarjeta',
				nombre: tarjeta ? tarjeta.nombre : '',
				message: tarjeta
					? tarjeta.rechazos.length > 0
						? 'Motivo de Rechazo: ' + tarjeta.rechazos[0].mensaje
						: ''
					: '',
			},
			{
				id: presentacion ? presentacion.id : '',
				estatus: presentacion ? presentacion.validaSeguimiento : '',
				idEntidad: idEntidad,
				isSendDisabled: isSendDisabled,
				tipo: 'P',
				entidad: 'TEMAINCLUIDO',
				ruta: 'temas/' + idEntidad + '/',
				title: 'Presentación',
				nombre: presentacion ? presentacion.nombre : '',
				message: presentacion
					? presentacion.rechazos.length > 0
						? 'Motivo de Rechazo: ' + presentacion.rechazos[0].mensaje
						: ''
					: '',
			},
			{
				id: adicional ? adicional.id : '',
				estatus: adicional ? adicional.validaSeguimiento : '',
				idEntidad: idEntidad,
				isSendDisabled: isSendDisabled,
				tipo: 'A',
				entidad: 'TEMAINCLUIDO',
				ruta: 'temas/' + idEntidad + '/',
				title: 'Adicionales',
				nombre: adicional ? adicional.nombre : '',
				message: adicional
					? adicional.rechazos.length > 0
						? 'Motivo de Rechazo: ' + adicional.rechazos[0].mensaje
						: ''
					: '',
			},
		];
		return datosMinos;
	};
	const onClickSendArchivos = (rol) => {
		rol = rol.toUpperCase();
		let estatus = rol === 'ENLACE' ? 'EP' : 'AC';
		estatus = rol === 'RESPONSABLE DE SEGUIMIENTO' ? 'APO' : estatus;
		inclusionThemesAPI.enviarNotificacionResponsable(id, estatus).then((response) => {
			notice('Notificación Enviada', 'success');
			setFlagRender(true);
		});
	};
	useEffect(() => {
		if (flagRender) {
			window.location.reload();
		}
	}, [flagRender, setFlagRender]);
	const clearForm = () => setTopic(defaultAddTopics);

	const onModalDelete = () => {
		setModalDelate(true);
	};

	const onDelete = () => {
		inclusionThemesAPI
			.eliminarTema(id)
			.then(() => {
				notice('Tema eliminado', 'success');
				history.push(
					`/seguimiento/agregar-documentacion-resoluciones/${idSession}`
				);
			})
			.catch((e) => notice('Ha ocurrido un error con su petición'));
		setModalDelate(false);
	};

	return (
		<>
			{add === true && (
				<BaseModal
					open={open}
					onConfirm={() => createTopic()}
					confirmLabel="Agregar"
					onClose={() => setOpen(false)}
					mainText="Agregar Tema"
					onCancel={() => setOpen(false)}
				>
					<UtilInputs
						formValues={topic}
						inputValues={addTopicsInputs(institutions, fundamentals)}
						onValuesChange={handleChange}
					/>
				</BaseModal>
			)}
			{id !== null && (
				<PageLayout title="Inclusión de Tema">
					<UtilInputs
						formValues={topic}
						inputValues={editTopicsInputs(institutions, disableForm)}
						onValuesChange={handleChange}
					/>
					<div className="mt-lg-10">
						<h3 className="col-auto mr-auto ">Documentos</h3>
						<Grid container className={classes.root} spacing={10}>
							{items.length > 0 ? (
								<TablaDocumentos
									disabled={sendDisabled}
									onClickEnviar={onClickSendArchivos}
									items={items}
									inpustfile={inpustfile}
									setFlagRender={setFlagRender}
								/>
							) : (
								<></>
							)}
						</Grid>
					</div>
					<Grid className={classes.containerButtons} container spacing={2}>
						<Grid className={classes.subContainerButtons} item md={12}>
							{update_button(onModalDelete, createTopic, disableForm).map(
								(button) => (
									<CustomButton
										key={button.title}
										mainText={button.title}
										color={button.color}
										onClick={button.onClick}
										disabled={button.disabled}
										className={button.className}
									/>
								)
							)}
						</Grid>
					</Grid>
				</PageLayout>
			)}
			<DeleteConsultModal
				open={modalDelete}
				setClose={setModalDelate}
				onDelete={onDelete}
			/>
		</>
	);
};

export default AddTopicModal;
